import { routerModel } from "@/router/router.model";
import { headerModel } from "@/shared/components/base/models/header-model";

export class AuthRedirectsService {
    afterLoginUrl = "";
    cancelLoginUrl = "";

    doRedirectAfterLogin() {
        headerModel.toggleSidebar(false);
        if (this.afterLoginUrl) {
            routerModel.router.push(this.afterLoginUrl);
            this.afterLoginUrl = "";
            this.cancelLoginUrl = "";
        } else {
            routerModel.router.push("/");
        }
    }

    doCancelLoginRedirect() {
        if (this.cancelLoginUrl) {
            routerModel.router.push(this.cancelLoginUrl);
            this.afterLoginUrl = "";
            this.cancelLoginUrl = "";
        } else {
            const previousPage = document.referrer;
            const currentDomain = window.location.origin;

            if (previousPage.startsWith(currentDomain)) {
                routerModel.router.back();
            } else {
                routerModel.router.push("/");
            }
        }
    }
}

let instance: AuthRedirectsService;
export function getAuthRedirectService() {
    if (!instance) {
        instance = new AuthRedirectsService();
    }

    return instance;
}
